
import styles from "../../../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { PatchStudentsData, getAcademicYearsData, getBranchesData, getEducationTypesData, getDepartmentsData, getSpecialitiesData, getCoursesData, getStudentsDetailData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import StudentHystoryContent from "./components/StudentHystoryContent"
import StudentHystoryPayContent from "./components/StudentHystoryPayContent"
import StudentContractPayContent from "./components/StudentContractPayContent"
import StudentHystoryPayListContent from "./components/StudentHystoryPayListContent"
import { Icon } from '../../../../../components/UnvUI/Icons'

const StudentDetailContent = ({ render, setRender, id, nameStudent, onBack, foun_id }) => {
  const { t } = useTranslation('common')

    const sections = [
        { key: "historypay", label: "История оплат", Component: StudentHystoryPayContent },
        { key: "contract", label: "Контракт", Component: StudentContractPayContent },
        { key: "hystory", label: "Движение студента", Component: StudentHystoryContent },
        { key: "paylist", label: "Оплата студента", Component: StudentHystoryPayListContent },
    ];

    const [activeSection, setActiveSection] = useState(null);

    const handleShowSection = (key) => {
        setActiveSection(prev => (prev === key ? null : key));
    };
    const componentRef = useRef();
    const componentRef1 = useRef();
    const [academicyears, setAcademicYears] = useState([]);
    const getAcademicYears = async (foun_id) => {
        try {
            let response = await getAcademicYearsData(foun_id, academicyears);
            setAcademicYears(response.data);

        } catch (error) {
        }
    };
    const [branches, setBranches] = useState([]);
    const getBranches = async (foun_id) => {
        try {
            let response = await getBranchesData(foun_id, branches);
            setBranches(response.data);

        } catch (error) {
        }
    };

    const [educationtypes, setEducationTypes] = useState([]);
    const getEducationTypes = async (foun_id) => {
        try {
            let response = await getEducationTypesData(foun_id, educationtypes);
            setEducationTypes(response.data);

        } catch (error) {
        }
    };

    const [departments, setDepartments] = useState([]);
    const getDepartments = async (id) => {
        try {
            let response = await getDepartmentsData(id, departments);
            setDepartments(response.data);

        } catch (error) {
        }
    };

    const [specialities, setSpecialities] = useState([]);
    const getSpecialities = async (id) => {
        try {
            let response = await getSpecialitiesData(id, departments);
            setSpecialities(response.data);

        } catch (error) {
        }
    };

    const [courses, setCourses] = useState([]);
    const getCourses = async (foun_id) => {
        try {
            let response = await getCoursesData(foun_id, courses);
            setCourses(response.data);

        } catch (error) {
        }
    };


    const [academicYearID, setAcademicYearID] = useState("");
    const [branchID, setBranchID] = useState("");
    const [departmentID, setDepartmentID] = useState("");
    const [educationTypeID, setEducationTypeID] = useState("");
    const [courseID, setCourseID] = useState("");
    const [specialitieID, setSpecialitieID] = useState("");

    const handleSelectAcademicYear = (id) => {
        setAcademicYearID(id);
    };
    const handleSelectBranch = (id) => {
        setBranchID(id);
        getDepartments(id)
        setDepartmentID("")
    };
    const handleSelectDepartment = (id) => {
        setDepartmentID(id);
        getSpecialities(id)
        setSpecialitieID("")
    };
    const handleSelectEducationType = (id) => {
        setEducationTypeID(id);
    };
    const handleSelectCourse = (id) => {
        setCourseID(id);
    };
    const handleSelectSpecialitie = (id) => {
        setSpecialitieID(id);
    };


    const [inn, setInn] = useState("");
    const [surname, setSurname] = useState("");
    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");
    const [citizenship, setCitizenship] = useState("");
    const [order, setOrder] = useState("");


    const [data, setData] = useState([]);
    const getData = async (id) => {
        try {
            let response = await getStudentsDetailData(id, data);
            setData(response.data);
            setInn(response.data.inn);
            setSurname(response.data.surname);
            setFirstName(response.data.first_name);
            setLastName(response.data.last_name);
            setCitizenship(response.data.citizenship);
            setOrder(response.data.order);
            handleSelectAcademicYear(response.data.academic_year)
            handleSelectBranch(response.data.branchID)
            handleSelectEducationType(response.data.educationtype)
            handleSelectDepartment(response.data.departmentID)
            handleSelectSpecialitie(response.data.speciality)
            handleSelectCourse(response.data.course)

        } catch (error) {
        }
    };

    useEffect(() => {

        getAcademicYears(foun_id);
        getBranches(foun_id);
        getCourses(foun_id);
        getEducationTypes(foun_id);
        getData(id)
        setRender(false);


    }, [render]);

    const handlePrint1 = useReactToPrint({
        content: () => componentRef1.current,
    });


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [activeForm, setActiveForm] = useState("");


    const [paymentAmount, setPaymentAmount] = useState("");
    const [paymentDate, setPaymentDate] = useState("");
    const [paymentOrder, setPaymentOrder] = useState("");
    const [paymentBase, setPaymentBase] = useState("");
    const handleSubmitPayment = async (event) => {
        event.preventDefault();

        if (!paymentAmount || !paymentDate || !paymentOrder || !paymentBase) {
            setNotify({
                isOpen: true,
                message: "Заполните все поля для оплаты!",
                type: "error",
            });
            return;
        }

        const formData = new FormData();
        formData.append('status', "pay");
        formData.append("amount", paymentAmount);
        formData.append("date", paymentDate);
        formData.append("order", paymentOrder);
        formData.append("base", paymentBase);

        let response = await PatchStudentsData(id, formData);

        setNotify({
            isOpen: true,
            message: "Статус успешно изменен!",
            type: "success",
            sound: "success"
        });

        setPaymentAmount("");
        setPaymentDate("");
        setPaymentOrder("");
        setPaymentBase("");
        setActiveForm("");
        setRender(true);

    };

    const [order_cancel_transfer, setOrderCancelTransfer] = useState("");
    const [order_graduate, setOrderGraduate] = useState("");
    const [order_cancel_graduate, setOrderCancelGraduate] = useState("");
    const [order_transfer, setOrderTransfer] = useState("");

    const [order_goincome, setOrderGoIncome] = useState("");
    const handleSubmitGoIncome = async (event) => {
        event.preventDefault();

        if (!order_goincome) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для Восстановления!",
                type: "error",
            });

        }

        else {
            const formData = new FormData();
            formData.append('status', "goincome");
            formData.append('order', order_goincome);
            let data = await PatchStudentsData(id, formData);
            setOrderGoIncome("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }

    }
    const handleSubmitCancelTransfer = async (event) => {
        event.preventDefault();

        if (!order_cancel_transfer) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для отмены перевода!",
                type: "error",
            });
        } else {
            const formData = new FormData();
            formData.append("status", "canceltransfer");
            formData.append("order", order_cancel_transfer);

            let data = await PatchStudentsData(id, formData);
            setOrderCancelTransfer("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success",
            });
            setRender(true);
        }
    };

    const handleSubmitGraduate = async (event) => {
        event.preventDefault();

        if (!order_graduate) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для выпуска!",
                type: "error",
            });
        } else {
            const formData = new FormData();
            formData.append("status", "graduate");
            formData.append("order", order_graduate);

            let data = await PatchStudentsData(id, formData);
            setOrderGraduate("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success",
            });
            setRender(true);
        }
    };

    const handleSubmitCancelGraduate = async (event) => {
        event.preventDefault();

        if (!order_cancel_graduate) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для отмены выпуска!",
                type: "error",
            });
        } else {
            const formData = new FormData();
            formData.append("status", "cancelgraduate");
            formData.append("order", order_cancel_graduate);

            let data = await PatchStudentsData(id, formData);
            setOrderCancelGraduate("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success",
            });
            setRender(true);
        }
    };

    const handleSubmitTransfer = async (event) => {
        event.preventDefault();

        if (!order_transfer) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для перевода!",
                type: "error",
            });
        } else {
            const formData = new FormData();
            formData.append("status", "transfer");
            formData.append("order", order_transfer);

            let data = await PatchStudentsData(id, formData);
            setOrderTransfer("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success",
            });
            setRender(true);
        }
    };

    const [order_goleave, setOrderGoLeave] = useState("");
    const handleSubmitGoLeave = async (event) => {
        event.preventDefault();

        if (!order_goleave) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для Отчисления!",
                type: "error",
            });

        }

        else {
            const formData = new FormData();
            formData.append('status', "goleave");
            formData.append('order', order_goleave);
            let data = await PatchStudentsData(id, formData);
            setOrderGoLeave("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }

    }
    const [order_goacadem, setOrderGoAcadem] = useState("");
    const handleSubmitGoAcadem = async (event) => {
        event.preventDefault();

        if (!order_goacadem) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для Академического отпуска!",
                type: "error",
            });

        }

        else {
            const formData = new FormData();
            formData.append('status', "goacadem");
            formData.append('order', order_goacadem);
            let data = await PatchStudentsData(id, formData);
            setOrderGoAcadem("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }
    }
    const [order_backacadem, setOrderBackAcadem] = useState("");
    const handleSubmitBackAcadem = async (event) => {
        event.preventDefault();
        if (!order_backacadem) {
            setNotify({
                isOpen: true,
                message: "Введите приказ для Восстановления!",
                type: "error",
            });

        }

        else {
            const formData = new FormData();
            formData.append('status', "backacadem");
            formData.append('order', order_backacadem);
            let data = await PatchStudentsData(id, formData);
            setOrderBackAcadem("");
            setActiveForm("");
            setNotify({
                isOpen: true,
                message: "Статус успешно изменен!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }
    }


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!inn) {
            setNotify({
                isOpen: true,
                message: "Введите ИНН!",
                type: "error",
            });

        }
        else if (!academicYearID) {
            setNotify({
                isOpen: true,
                message: "Выберите учебный год!",
                type: "error",
            });

        }
        else if (!educationTypeID) {
            setNotify({
                isOpen: true,
                message: "Выберите вид обучения!",
                type: "error",
            });

        }
        else if (!specialitieID) {
            setNotify({
                isOpen: true,
                message: "Выберите специальность!",
                type: "error",
            });

        }
        else if (!courseID) {
            setNotify({
                isOpen: true,
                message: "Выберите курс!",
                type: "error",
            });

        }


        else if (!surname) {
            setNotify({
                isOpen: true,
                message: "Введите Фамилию!",
                type: "error",
            });

        }
        else if (!first_name) {
            setNotify({
                isOpen: true,
                message: "Введите Имя!",
                type: "error",
            });

        }

        else if (!citizenship) {
            setNotify({
                isOpen: true,
                message: "Введите гражданство!",
                type: "error",
            });

        }
        else if (!order) {
            setNotify({
                isOpen: true,
                message: "Введите приказ о зачислении!",
                type: "error",
            });

        }


        else {
            const formData = new FormData();
            formData.append('inn', inn);
            formData.append('status', "edit");
            formData.append('order', order);
            formData.append('academic_year', academicYearID);
            formData.append('citizenship', citizenship);
            formData.append('speciality', specialitieID);
            formData.append('educationtype', educationTypeID);
            formData.append('course', courseID);
            formData.append('last_name', last_name);
            formData.append('surname', surname);
            formData.append('first_name', first_name);
            let data = await PatchStudentsData(id, formData);


            setInn("");
            setSurname("");
            setFirstName("");
            setLastName("");
            setCitizenship("");
            setOrder("");
            setAcademicYearID("");
            setBranchID("");
            setDepartmentID("");
            setEducationTypeID("");
            setCourseID("");
            setSpecialitieID("");

            setNotify({
                isOpen: true,
                message: "Данные успешно изменены!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }

    };

    useEffect(() => {

        setRender(false);


    }, [render]);


    return (
        <>

            <div className={styles.content_header}>
                <div className={styles.content_header_in}>
                    <Button className={styles.btn_pin} onClick={onBack}>⬅ Назад</Button>
                    <h2 className={styles.project__h}>Обучающиеся/{nameStudent}</h2>
                </div>


            </div>

            <div className={styles.content_header}>
                <div className={styles.content_header_in}>
                    <h2 className={styles.project__h}>{t('auto.components_studentdetailcontent.k1')}</h2>

                </div>

                <div className={styles.table__item__div}>
                    {activeForm ? (

                        <button className={styles.open_btn_sub_two} style={{ background: "black" }} onClick={() => setActiveForm("")}>
                            Закрыть <Icon name="close" />
                        </button>


                    ) : ""}
                    {data.status === "Переведен(а)" && (
                        <button
                            onClick={() => setActiveForm("cancelTransfer")}
                            className={styles.open_btn_sub_two}
                            style={{ background: "#999" }}
                        >
                            Отменить перевод
                        </button>
                    )}
                    


                    {data.status === "Зачислен(а)" && (
                        <>
                            <button
                                onClick={() => setActiveForm("payment")}
                                className={styles.open_btn_sub_two}
                                style={{ background: "#0a62a3", marginRight: "40px" }}
                            >
                                Принять оплату
                            </button>
                            <button onClick={() => setActiveForm("edit")} className={styles.open_btn_sub_two} style={{ background: "#5c5cff" }}>
                                Изменить
                            </button>
                            <button onClick={() => setActiveForm("goAcadem")} className={styles.open_btn_sub_two} style={{ background: "#ec9900ff" }}>
                                Академический отпуск
                            </button>
                            <button onClick={() => setActiveForm("goLeave")} className={styles.open_btn_sub_two} style={{ background: "#a00000ff" }}>
                                Отчислить
                            </button>
                            <button onClick={() => setActiveForm("graduate")} className={styles.open_btn_sub_two} style={{ background: "#008000ff" }}>
                                Выпустить
                            </button>
                            <button onClick={() => setActiveForm("transfer")} className={styles.open_btn_sub_two} style={{ background: "#333333" }}>
                                Перевести
                            </button>
                        </>
                    )}

                    {data.status === "Отчислен(а)" && (
                        <button onClick={() => setActiveForm("goIncome")} className={styles.open_btn_sub_two}>
                            Восстановить
                        </button>
                    )}

                    {data.status === "В академическом отпуске" && (
                        <button onClick={() => setActiveForm("backAcadem")} className={styles.open_btn_sub_two}>
                            Вернуть из академического отпуска
                        </button>
                    )}

                    {data.status === "Выпущен(а)" && (
                        <button onClick={() => setActiveForm("cancelGraduate")} className={styles.open_btn_sub_two} style={{ background: "#999" }}>
                            Отменить выпуск
                        </button>
                    )}


                </div>


            </div>
            <table className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                    <tr className={styles.table__row}>

                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('pages.form1NK.year_label')}</span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('auto.components_educationtypecontent.k1')}</span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('auth.inn')}</span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('user.last_name')} </span>
                        </th>

                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('user.first_name')} </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('user.middle_name')} </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('foreign.col_citizenship')} </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('archive.col_specialty')} </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('dpo.course')} </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('statements.list.order')} </span>
                        </th>

                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>{t('common.status')} </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}> </span>
                        </th>
                    </tr>
                </thead>

                <tbody className={styles.table__body}>


                    <tr className={styles.table__row} key={data.id}>

                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.academic_year_name}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.educationtype_name}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.inn}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.surname}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.first_name}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.last_name}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.citizenship}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.speciality_name}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.course_name}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                {data.order}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>
                            <span
                                className={styles.table__title}
                                style={{
                                    fontWeight: '700',
                                    padding: '5px',
                                    borderRadius: '6px',
                                    display: "block",
                                    textAlign: "center",
                                    background:
                                        data.status === 'Зачислен(а)' ? '#5C5CFF' :
                                            data.status === 'Отчислен(а)' ? '#a00000ff' :
                                                data.status === 'В академическом отпуске' ? '#ec9900ff' :
                                                    data.status === 'Переведен(а)' ? '#333333' :
                                                        data.status === 'Выпущен(а)' ? '#008000' :
                                                            'transparent',
                                    color: data.status ? 'white' : 'inherit',
                                }}
                            >
                                {data.status || ''}
                            </span>
                        </td>
                        <td className={styles.table__item_student}>

                        </td>

                    </tr>


                    

                </tbody>


            </table>
            {activeForm ? (
                <div className={styles.content_header_two_stud}>
                    <h2 className={styles.project__h}>{t('auto.component_employeedetailforms.k1')}</h2>

                    {activeForm === "payment" && (
                        <form onSubmit={handleSubmitPayment} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k2')}</label>
                                    <input
                                        type="number"
                                        placeholder={t('auto.components_expensescontent.k13')}
                                        value={paymentAmount}
                                        onChange={(e) => setPaymentAmount(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k3')}</label>
                                    <input
                                        type="date"
                                        value={paymentDate}
                                        onChange={(e) => setPaymentDate(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k4')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k24')}
                                        value={paymentOrder}
                                        onChange={(e) => setPaymentOrder(e.target.value)}
                                    />
                                </div>

                                <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px" }}>
                                    <label>{t('pages.ordersPage.ground_field')}</label>
                                    <select
                                        value={paymentBase}
                                        onChange={(e) => setPaymentBase(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_checkcontent.k4')}</option>
                                        <option value="Оплата за обучение">{t('auto.components_studenthystorypaycontent.k3')}</option>
                                        <option value="Предоплата">{t('auto.components_studenthystorypaycontent.k4')}</option>
                                        <option value="Оформление документа">{t('auto.components_studenthystorypaycontent.k5')}</option>
                                        <option value="За разницу">{t('auto.components_studenthystorypaycontent.k6')}</option>
                                        <option value="За восстановление">{t('auto.components_studenthystorypaycontent.k7')}</option>
                                    </select>
                                </div>
                            </div>

                            <div className={styles.create_footer} style={{ justifyContent: "start" }}>
                                <button type="submit" className={styles.open_btn_sub}>
                                    {t('auto.components_studentdetailcontent.k5')}
                                </button>
                            </div>
                        </form>
                    )}


                    {activeForm === "edit" && (
                        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('pages.employeeWizard.inn_lbl')}</label>
                                    <input
                                        type="number"
                                        placeholder={t('auto.components_studentdetailcontent.k25')}
                                        value={inn}
                                        name="name"
                                        onChange={(e) => setInn(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={styles.div_check}>
                                <div>
                                    <label>{t('auto.components_contractamountcontent.k3')}</label>
                                    <select
                                        value={academicYearID}
                                        onChange={(e) => handleSelectAcademicYear(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_contractamountcontent.k4')}</option>
                                        {Array.isArray(academicyears) && academicyears.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label>{t('auto.components_contractamountcontent.k9')}</label>
                                    <select
                                        value={educationTypeID}
                                        onChange={(e) => handleSelectEducationType(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_contractamountcontent.k10')}</option>
                                        {Array.isArray(educationtypes) && educationtypes.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className={styles.div_check}>

                                <div>
                                    <label>{t('auto.components_contractamountcontent.k5')}</label>
                                    <select
                                        value={branchID}
                                        onChange={(e) => handleSelectBranch(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_contractamountcontent.k6')}</option>
                                        {Array.isArray(branches) && branches.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label>{t('auto.components_contractamountcontent.k7')}</label>
                                    <select
                                        value={departmentID}
                                        onChange={(e) => handleSelectDepartment(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_contractamountcontent.k8')}</option>
                                        {Array.isArray(departments) && departments.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k6')}</label>
                                    <select
                                        value={specialitieID}
                                        onChange={(e) => handleSelectSpecialitie(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_studentdetailcontent.k7')}</option>
                                        {Array.isArray(specialities) && specialities.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k8')}</label>
                                    <select
                                        value={courseID}
                                        onChange={(e) => handleSelectCourse(e.target.value)}
                                    >
                                        <option value="">{t('auto.components_studentdetailcontent.k9')}</option>
                                        {Array.isArray(courses) && courses.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k10')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k26')}

                                        value={surname}
                                        name="name"
                                        onChange={(e) => setSurname(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k11')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k27')}

                                        value={first_name}
                                        name="name"
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k12')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k28')}

                                        value={last_name}
                                        name="name"
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k13')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k29')}

                                        value={citizenship}
                                        name="name"
                                        onChange={(e) => setCitizenship(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>{t('auto.component_employeedetailforms.k3')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}

                                        value={order}
                                        name="name"
                                        onChange={(e) => setOrder(e.target.value)}
                                    />
                                </div>
                            </div>


                            <div className={styles.create_footer} style={{ justifyContent: "start" }}>


                                <button
                                    type="submit"
                                    className={styles.open_btn_sub}

                                >
                                    {t('common.save')}
                                </button>

                            </div>
                        </form>
                    )}
                    {activeForm === "cancelTransfer" && (
                        <form onSubmit={handleSubmitCancelTransfer} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k14')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_cancel_transfer}
                                        onChange={(e) => setOrderCancelTransfer(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('auto.components_studentdetailcontent.k15')}</button>
                        </form>
                    )}

                    {activeForm === "goAcadem" && (
                        <form onSubmit={handleSubmitGoAcadem} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k16')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_goacadem}
                                        onChange={(e) => setOrderGoAcadem(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('orders.academic_leave')}</button>
                        </form>
                    )}

                    {activeForm === "backAcadem" && (
                        <form onSubmit={handleSubmitBackAcadem} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k17')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_backacadem}
                                        onChange={(e) => setOrderBackAcadem(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('practice.return_btn')}</button>
                        </form>
                    )}

                    {activeForm === "goLeave" && (
                        <form onSubmit={handleSubmitGoLeave} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k18')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_goleave}
                                        onChange={(e) => setOrderGoLeave(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('students.expel')}</button>
                        </form>
                    )}

                    {activeForm === "goIncome" && (
                        <form onSubmit={handleSubmitGoIncome} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k19')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_goincome}
                                        onChange={(e) => setOrderGoIncome(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('common.restore')}</button>
                        </form>
                    )}

                    {activeForm === "graduate" && (
                        <form onSubmit={handleSubmitGraduate} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k20')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_graduate}
                                        onChange={(e) => setOrderGraduate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('students.graduate')}</button>
                        </form>
                    )}

                    {activeForm === "cancelGraduate" && (
                        <form onSubmit={handleSubmitCancelGraduate} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k21')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_cancel_graduate}
                                        onChange={(e) => setOrderCancelGraduate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('auto.components_studentdetailcontent.k22')}</button>
                        </form>
                    )}

                    {activeForm === "transfer" && (

                        <form onSubmit={handleSubmitTransfer} style={{ width: "100%" }}>
                            <div className={styles.form_input}>
                                <div>
                                    <label>{t('auto.components_studentdetailcontent.k23')}</label>
                                    <input
                                        type="text"
                                        placeholder={t('auto.components_studentdetailcontent.k30')}
                                        value={order_transfer}
                                        onChange={(e) => setOrderTransfer(e.target.value)}
                                    />
                                </div>
                            </div>
                            <button type="submit" className={styles.open_btn_sub_two}>{t('statements.info.transfer')}</button>
                        </form>
                    )}

                </div>
            ) : ""}
            <div className={styles.project__body_second}>
                <div style={{ display: "flex" }}>
                    <div className={styles.project__menu}>
                        {sections.map(({ key, label }) => (
                            <div key={key} className={
                                activeSection === key
                                    ? styles.project__menu__item__active
                                    : styles.project__menu__item
                            }>
                                <h2
                                    onClick={() =>
                                        handleShowSection(activeSection === key ? null : key)
                                    }
                                    style={{ cursor: 'pointer' }}
                                >
                                    {label} <Icon name={activeSection === key ? 'chevronUp' : 'chevronDown'} />
                                </h2>
                            </div>
                        ))}

                    </div>
                    <button className={styles.btn_print} style={{ fontSize: "28px" }} onClick={handlePrint1}><Icon name="print" /></button>
                </div>
            </div>
            <div ref={componentRef1} style={{ width: "100%" }}>
                {sections.map(({ key, Component }) =>
                    activeSection === key && Component ? (
                        <Component
                            key={key}
                            render={render}
                            setRender={setRender}
                            id={id}
                            datastudent={data}
                        />
                    ) : null
                )}

            </div>
            <Notification notify={notify} setNotify={setNotify} />


        </>


    );
};

export default StudentDetailContent;
